import * as types from '../constants/paymentConstants';
import appConstants from '../appConstants';
import config from '../config';
import moment from 'moment';
const initialState = {
  addPayReqFlag:false,
  editPayReqFlag:false,
  historicalPaymentReqData:[],
  accountSSIdet:[],
  accountDetails:null,
  payRandomNo:0,
  histRandomNo:0,
  randomNo:0,
  histPaymentLoader:false,
  paymentRequestData: {
    paymentReqData:[],
    paymentReqMap: null
  },
  payStkList:[],
  loaderFlag:false,
  accDetRandomNo:0,
  holidayList:[],
  holidayRandomNo:0
};
const getPayDecimal = (CCYG) => {
  var qtyDec;
  if(CCYG=== 'M'){
    qtyDec=3;
  }else {
    qtyDec=2;
  }
  return qtyDec;
}
const getPaymentRequestData = (msgData,paymentData) =>{
  let tempArray=[];
  var tempMap= new Map();
  if (paymentData.paymentReqMap !== null) {
    tempMap = paymentData.paymentReqMap;
  }
  msgData.map((item) => {
    let dataObj={
      'docno':item.docno,
      'SSI_number':item.SSI_number,
      'valdate':item.valdate,
      'stk_type_name':item.stk_type_name,
      'stk_type': item.stk_type,
      'stk_group':item.stk_group,
      'qty':(item.stk_group === 'M'?parseFloat(item.qty).toLocaleString('en',{ minimumFractionDigits: 3 }):parseFloat(item.qty).toLocaleString('en',{ minimumFractionDigits: 2 })),
      'RSC': item.status,
      'RS': item.statusdesc,
      'CHARGS':parseFloat(item.pmr_chg).toLocaleString('en',{ minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits:config.AmountRoundOFF}),
      'remarks':item.remarks
    }
    tempArray.push(dataObj);
    var obj = {
      'id':item.docno,
      'SSI_number':item.SSI_number ,
      'accCode':item. acc_code,
      'docNo':item.docno,
      'process_rmk': item.process_remarks,
      'quantity': (item.stk_group === 'M'?parseFloat(item.qty).toFixed(config.QuantityRoundOff):parseFloat(item.qty).toFixed(2)),
      'remarks': item.remarks,
      'qty':item.qty,
      'RSC': item.status,
      'RS': item.statusdesc,
      'cmdty': item.stk_type_name,
      'stk_type': item.stk_type,
      'stk_group':item.stk_group,
      'CHARGS':parseFloat(item.pmr_chg).toLocaleString('en',{ minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits:config.AmountRoundOFF}),
      'valdate': item.valdate
    };
    tempMap.set(item.docno, obj);
  });
  paymentData.paymentReqData=tempArray;
  paymentData.paymentReqMap=tempMap;
  return paymentData;
}
const updatePaymentRequestData = (msg,paymentData,accDet) =>{
  let defaultAC=JSON.parse(localStorage.getItem('DefaultAC'));
  if(msg.AC === defaultAC.AC){
    let tempArray=[];
    if (paymentData){
      if (paymentData.paymentReqData !== undefined) {
        if (paymentData.paymentReqData.length !== 0) {
          tempArray = paymentData.paymentReqData;
        }
      }
    }
    var tempMap= new Map();
    if (paymentData.paymentReqMap !== null) {
      tempMap = paymentData.paymentReqMap;
    }
  if(msg.BCM === appConstants.PAYMENT_REQUEST_APRVREJ){
    for (let i = 0; i < tempArray.length; i++) {
      if (tempArray[i].docno === msg.DN) {
        if(msg.RSC === 'APR'){
          tempArray[i].RSC=msg.RSC;
          tempArray[i].RS= msg.RS;
          break;
        }else {
          tempArray.splice(i,1)
        }
      }
    }
    var tempobj=tempMap.get(msg.DN);
        if(msg.RSC === 'APR'){
          tempobj.RSC=msg.RSC;
          tempobj.RS= msg.RS;
          tempobj.CHARGS= parseFloat(msg.pmr_chg).toLocaleString('en',{ minimumFractionDigits: config.AmountRoundOFF ,maximumFractionDigits: config.AmountRoundOFF})
          tempMap.set(msg.DN,tempobj);
        }else {
          tempMap.delete(msg.DN);
        }
    paymentData.paymentReqMap=tempMap;
    paymentData.paymentReqData=tempArray;
    return paymentData;
  }else {
    let qtyDec =getPayDecimal(msg.CCYG);
      if(msg.OMT !== 6){
          let dataObj = {
            'id':msg.ID,
            'SSI_number':msg.SSI,
            'accCode':msg.AC,
            'docno':msg.DN,
            //'loc_code':msg.LOC,
            //'loc_desc':msg.LOCD,
            'qty': parseFloat(msg.PQ).toLocaleString('en',{ minimumFractionDigits:qtyDec,maximumFractionDigits: qtyDec}),
            'remarks': msg.RMK,
            'RSC': msg.RSC,
            'RS': msg.RS,
            'stk_type_name': msg.CCYN,
            'stk_type': msg.CCY,
            'CHARGS':(msg.pmr_chg ? parseFloat(msg.pmr_chg).toLocaleString('en',{ minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits:config.AmountRoundOFF}) : '0.00'),
            'valdate': msg.VD
          };
          let obj = {
            'id':msg.docno,
            'SSI_number':msg.SSI ,
            'accCode':msg. AC,
            'docNo':msg.DN,
            //'loc_code':msg.LOC,
            //'loc_desc':msg.LOCD,
            'quantity':parseFloat(msg.PQ).toFixed(qtyDec),
            'remarks': msg.RMK,
            'RSC': msg.RSC,
            'RS': msg.RS,
            'cmdty': msg.CCYN,
            'stk_type': msg.CCY,
            'valdate': msg.VD,
            'CHARGS':(msg.pmr_chg ? parseFloat(msg.pmr_chg).toLocaleString('en',{ minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits:config.AmountRoundOFF}) : '0.000'),
          };
          tempMap.set(msg.DN,obj);
          let flag= false;
          for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].docno === msg.DN) {
              flag=true;
                tempArray[i] = dataObj;
              break;
            }
          }
          if(!flag){
            tempArray.unshift(dataObj);
          }
        }else {
          tempMap.delete(msg.DN);
          for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].docno === msg.DN) {
                tempArray.splice(i,1)
              break;
            }
          }
        }
          paymentData.paymentReqData=tempArray;
          paymentData.paymentReqMap=tempMap;
          return paymentData;
      }
  }else {
    return paymentData;
  }
}
//get Historical data
const getHistoricalData = (histdata)=>{
  try {
    return histdata.map((item) => {
      item.qty=(item.stk_group === 'M'?parseFloat(item.qty).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff }):parseFloat(item.qty).toLocaleString('en',{ minimumFractionDigits: 2 }));
      return {
        ...item
      };
    });
  } catch (e) {
    console.log("exception "+ e);
  }

}
//updtae historicaldata
const updateHistoricalData = (msg,historicalPaymentReqData,accDet) =>{
  let qtyDec=getPayDecimal(msg.CCYG);
  let defaultAC=JSON.parse(localStorage.getItem('DefaultAC'));
  if(msg.BCM === appConstants.PAYMENT_REQUEST_APRVREJ){
  if(msg.AC === defaultAC.AC){
    if(msg.RSC !== 'APR'){
      let tempArray=[];
      if (historicalPaymentReqData){
          if (historicalPaymentReqData.length !== 0) {
            tempArray = historicalPaymentReqData;
          }
      }
      let dataObj={
        "docno":msg.DN,
        "valdate":msg.VD,
        "acc_code":msg.AC,
        "stk_type":msg.CCY,
        "stk_type_name":msg.CCYN,
        "qty":parseFloat(msg.PQ).toLocaleString('en',{ minimumFractionDigits:qtyDec,maximumFractionDigits: qtyDec}),
        "status":msg.RSC,
        "statusdesc":msg.RS,
        "SSI_number":msg.SSI,
        "JRV_docno":msg.JRV_docno,
        "remarks":msg.RMK
      }
        tempArray.unshift(dataObj);
      historicalPaymentReqData=tempArray;
    }
  }
  return historicalPaymentReqData;
}else {
  return historicalPaymentReqData;
}
return historicalPaymentReqData;
}

const getStkList = (accDetails) =>{
  try {
    let defaultAC=JSON.parse(localStorage.getItem('DefaultAC'));
    let cmdtyArray=[];
      for(let i=0; i<accDetails.length; i++){
        if(accDetails[i].acc_code === defaultAC.AC){
            cmdtyArray.push({stk_type:accDetails[i].stk_type,
                             stk_type_Name:accDetails[i].stk_type_name,
                             stk_grp:accDetails[i].stk_group,
                             TYPE:accDetails[i].TYPE
                            });
        }
      }
      return cmdtyArray;
  } catch (e) {
    console.log("getStkList exception"+ e);
  }
}

const getAccountDetails =(msgData,accountDetails)=>{
  try {
    const accountList = JSON.parse(localStorage.getItem('TS')).ACD;
    var tempMap= new Map();
      for(let i=0; i<accountList.length; i++){
      let tempArray=[];
      msgData.map((item)=>{
          if(accountList[i].C === item.acc_code){
            tempArray.push(item)
          }
      })
      tempMap.set(accountList[i].C ,tempArray);
     }
    accountDetails=tempMap;
    return accountDetails;
  } catch (e) {
    console.log(" exception "+ e);
  }

}
const updateAccountDetails = (accDet,msg) =>{
  var tempMap= new Map();
  tempMap=accDet
  if(msg.BCM === appConstants.UPDATE_PR_SSI){
    let accDetails=accDet.get(msg.AC);
    for(let i=0; i<accDetails.length; i++){
      if(msg.DET.length === 0){
        accDetails[i].SSI=[];
      }else {
        msg.DET.map((item)=>{
          if(item.STN === accDetails[i].stk_type_name){
            accDetails[i].SSI=item.SSI
          }
        })
      }
    }
    tempMap.set(msg.AC,accDetails);
    return tempMap;
  }else if(msg.BCM === appConstants.UPDATE_PR_CUTOFF){
      const accountList = JSON.parse(localStorage.getItem('TS')).ACD;
      for(let i=0; i<accountList.length; i++){
        let accDetails=accDet.get(accountList[i].C);
        for(let j=0; j<accDetails.length; j++){
          msg.D.map((item)=>{
            if(accDetails[j].stk_type === item.ST){
              accDetails[j].UTCTIME= item.TIME;
              accDetails[j].TYPE=item.TYPE;
              accDetails[j].DATE=item.DATE;
            }
          })
        }
        accDet.set(accountList[i].C,accDetails);
     }
    return accDet;
  }else if(msg.BCM === appConstants.UPDATE_HOLIDAY){
      const accountList = JSON.parse(localStorage.getItem('TS')).ACD;
      for(let i=0; i<accountList.length; i++){
        let accDetails=accDet.get(accountList[i].C);
        for(let j=0; j<accDetails.length; j++){
          msg.D.STK.map((item)=>{
            if(accDetails[j].stk_type === item.stk_type){
              accDetails[j].UTCTIME= item.utcTime;
              accDetails[j].DATE=item.validDate;
            }
          })
        }
        accDet.set(accountList[i].C,accDetails);
     }
    return accDet;
  }else {
    return accDet;
  }

}
const getHolidayList =(responseData,holidayList)=>{
    if(responseData){
      return responseData.map((item, index) => {
      item.Date=moment(item.Date).format("DD/MM/YYYY");
      return {...item};
      });
    }else {
      return holidayList;
    }
}
const updateHolidayList = (holidayList,msg)=>{
  try {
    if(msg.BCM === appConstants.ADD_PMR_HOLIDAY){
     msg.DATE=moment(msg.DATE).format("DD/MM/YYYY");
      if(holidayList.findIndex(x => (x.Date === msg.DATE) ) !== -1){
      holidayList[holidayList.findIndex(x => (x.Date === msg.DATE) )].PMR = msg.PMR;
    }else{
      let obj={Date: msg.DATE, PMR: msg.PMR}
      holidayList.push(obj);
    }
    return holidayList;
  }else if (msg.BCM === appConstants.DELETE_PMR_HOLIDAY) {
    msg.DATE=moment(msg.DATE).format("DD/MM/YYYY");
    if(holidayList.findIndex(x => (x.Date === msg.DATE) ) !== -1){
       let index =holidayList[holidayList.findIndex(x => (x.date === msg.DATE))];
       holidayList.splice(index, 1);
    }
    return holidayList;
  }else {
    return holidayList;
  }
} catch (e) {
  console.log("Exception holiday "+e);
} finally {

}
}
const generateHolidayMap=(holidayList)=>{
  try {
      var tempMap= new Map();
      holidayList.D.map((item)=>{
      let dateMonth=moment(item.date).format("DD/MM")
      tempMap.set(dateMonth,{occur_everyYear:item.occur_everyYear})
    })
    return tempMap;
  } catch (e) {
    console.log("exception: "+ e);
  }

}
const updateHolidayMap = (msg)=>{
  var tempMap= new Map();
  msg.D.DET.map((item)=>{
    let yearflag= (item.occur_everyYear === '1' ? true:false)
    tempMap.set(moment(item.Date).format("DD/MM"),{occur_everyYear:yearflag})
  })
  return tempMap;
}
export default function(state = initialState, action)  {
  switch (action.type) {
    case types.ADD_PAYMENT_MODAL:
     return{
       ...state,
       addPayReqFlag:action.flag
     }
    case types.MODIFY_PAYMENT_MODAL:
     return{
       ...state,
       editPayReqFlag:action.flag
     }
     case types.GET_PAY_REQ_DET:
      return{
        ...state,
      }
     case types.GET_PAY_REQ_DET_SUCCESS:
     var randomNo=Math.floor((Math.random() * 100) + 1);
      return{
        ...state,
        paymentRequestData:getPaymentRequestData(action.result.data,state.paymentRequestData),
        payRandomNo:randomNo,
        loaderFlag:false
      }
      case types.GET_PAY_REQ_DET_FAILURE:
       return{
         ...state,
         paymentRequestData:state.paymentRequestData
       }
       case types.UPDATE_PAY_REQ_DET:
       var randomNo=Math.floor((Math.random() * 100) + 1);
       return{
         ...state,
         paymentRequestData:updatePaymentRequestData(action.msg,state.paymentRequestData,state.accountDetails),
         payRandomNo:randomNo,
         randomNo:randomNo
       }
      case types.GET_HISTORICAL_PAYREQ_DET:
        return{
          ...state,
        }
      case types.GET_HISTORICAL_PAYREQ_DET_SUCCESS:
        var randomNo=Math.floor((Math.random() * 100) + 1);
        return{
          ...state,
          historicalPaymentReqData:getHistoricalData(action.result.data),
          histPaymentLoader:false,
          histRandomNo:randomNo
        }
      case types.GET_HISTORICAL_PAYREQ_DET_FAILURE:
         return{
           ...state,
         }
      case types.GET_ACCOUNT_DET:
        return{
          ...state,
        }
      case types.GET_ACCOUNT_DET_SUCCESS:
      var randomNo=Math.floor((Math.random() * 10000000000) + 1);
      let defaultAC=JSON.parse(localStorage.getItem('DefaultAC'));
        return{
          ...state,
          accountDetails:getAccountDetails(action.result.data,state.accountDetails),
          payStkList:getStkList(action.result.data),
          accDetRandomNo:randomNo
        }
      case types.GET_ACCOUNT_DET_FAILURE:
         return{
           ...state,
           accountDetails:state.accountDetails
         }
      case types.UPDATE_PAY_SSI_DEP:
      var randomNo=Math.floor((Math.random() * 100) + 1);
      return{
        ...state,
        accountDetails:updateAccountDetails(state.accountDetails,action.msg),
        accDetRandomNo:randomNo
      }
      case types.GET_HOLIDAY_LIST:
        return{
        ...state,
      }
      case types.GET_HOLIDAY_LIST_SUCCESS:
        return{
        ...state,
        holidayList:getHolidayList(action.result.data, state.holidayList)
      }
      case types.GET_HOLIDAY_LIST_FAILURE:
        return{
        ...state,
      }
      case types.EXPORT_PAYMENT_REPORT:
      return{
        ...state
      }
      case types.UPDATE_HOLIDAY_LIST:
      var randomNo=Math.floor((Math.random() * 100000) + 1);
        return{
        ...state,
        accountDetails:updateAccountDetails(state.accountDetails,action.msg),
        accDetRandomNo:randomNo
      }
      case types.ADD_PMR_HOLIDAY:
      var randomNo=Math.floor((Math.random() * 100000) + 1);
        return{
        ...state,
        holidayList:updateHolidayList(state.holidayList,action.msg),
        holidayRandomNo:randomNo
      }
      case types.DELETE_PMR_HOLIDAY:
      var randomNo=Math.floor((Math.random() * 100000) + 1);
        return{
        ...state,
        holidayList:updateHolidayList(state.holidayList,action.msg),
        holidayRandomNo:randomNo
      }
      case types.RESET_STATE:
         return{
           ...state,
           addPayReqFlag:false,
           editPayReqFlag:false,
           historicalPaymentReqData:[],
           accountDetails:null,
           payRandomNo:0,
           histPaymentLoader:false,
           paymentRequestData: {
             paymentReqData:[],
             paymentReqMap: null
           },
           payStkList:[],
           holidayList:[],
           loaderFlag:false
         }
    default:
		    return state;
		}
  }
